import {
  EmptyInput,
  InputGroup,
  InputRow,
  ModelAlphaInput,
  ModelDateDMY,
  ModelSelect,
} from '@equifinance/shared';
import Section from '../../components/Section';
import { stageOnOrAfter } from '../../../../contexts/helpers';
import { useAccountContext } from '../../../../contexts';
import {
  Applicant, CitizenshipStatus, MaritalStatus, PlanToPayLoanRetire, Titles,
} from '../../../../contexts/account/Account';
import { Stages } from '../../../../types/Stages';

export default function PersonalDetails({
  applicant,
  index,
}: {
  applicant: Applicant,
  index: number,
}) {
  const { account, creditSearchCompleted } = useAccountContext();

  const {
    stage, errors, warnings,
  } = account;

  return (
    <Section
      id={`${applicant?.personalDetails?.id}`}
      key={`${applicant.id}-personal-details`}
      title="Personal details"
      titleIcon={<></>}
      errors={errors}
      warnings={warnings}
      level={1}
    >
      <InputGroup>
        <InputRow>
          <ModelSelect
            label="Title"
            options={Titles}
            field={`applicants[${index}].personalDetails.title`}
            required
            disabled={stage !== Stages.CreditDecision || creditSearchCompleted}
          />
          <EmptyInput />
        </InputRow>
        <InputRow>
          <ModelAlphaInput
            label="First name"
            field={`applicants[${index}].personalDetails.firstName`}
            required
            disabled={stage !== Stages.CreditDecision || creditSearchCompleted}
          />
          <ModelAlphaInput
            label="Middle name"
            field={`applicants[${index}].personalDetails.middleName`}
            disabled={stage !== Stages.CreditDecision || creditSearchCompleted}
          />
        </InputRow>

        <InputRow>
          <ModelAlphaInput
            label="Last name"
            field={`applicants[${index}].personalDetails.lastName`}
            required
            disabled={stage !== Stages.CreditDecision || creditSearchCompleted}
          />
          <ModelAlphaInput
            label="Previous last name"
            field={`applicants[${index}].personalDetails.previousLastName`}
            disabled={stage !== Stages.CreditDecision || creditSearchCompleted}
          />
        </InputRow>
        <InputRow>
          <ModelDateDMY
            label="Date of birth"
            field={`applicants[${index}].personalDetails.dateOfBirth`}
            showDay
            disabled={stage !== Stages.CreditDecision || creditSearchCompleted}
            required
          />
          {stageOnOrAfter(stage, Stages.Packaging) ? (
            <ModelSelect
              label="Marital status"
              field={`applicants[${index}].personalDetails.maritalStatus`}
              options={MaritalStatus}
              required
            />
          ) : (
            <EmptyInput />
          )}
        </InputRow>

        {stageOnOrAfter(stage, Stages.Packaging) && (
          <>
            <InputRow>
              <ModelSelect
                label="Right to reside in the UK"
                field={`applicants[${index}].personalDetails.citizenshipStatus`}
                options={CitizenshipStatus}
                required
                placeholder="Please select"
              />
              {applicant?.personalDetails?.isLendingIntoRetirement ? (
                <ModelSelect
                  label="How do you plan to pay for the loan when you retire?"
                  field={`applicants[${index}].personalDetails.planToPayLoanRetire`}
                  options={PlanToPayLoanRetire}
                  required
                  placeholder="Please select"
                />
              ) : (
                <EmptyInput />
              )}
            </InputRow>
          </>
        )}
      </InputGroup>
    </Section>
  );
}
